
// PURCHASES
export const GET_PURCHASES = "/api/v1/purchases";
export const ADD_NEW_PURCHASE = "/api/v1/purchases";
export const UPDATE_PURCHASE = "/api/v1/purchases";
export const DELETE_PURCHASE = "/api/v1/purchases";


// INVOICES
export const GET_INVOICES = "/api/v1/invoices";
export const ADD_NEW_INVOICE = "/api/v1/invoices";
export const UPDATE_INVOICE = "/api/v1/invoices";
export const DELETE_INVOICE = "/api/v1/invoices";


